import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AccountState } from '@store/reducers';

export const selectAccountState = createFeatureSelector<AccountState>('account');

export const selectAccountLoading = createSelector(
  selectAccountState,
  (state) => state.loading
);

export const selectAccountList = createSelector(
  selectAccountState,
  (state) => state.accountList
);

export const selectAccountTableList = createSelector(
  selectAccountState,
  (state) => state.accountTableList
);

export const selectAccountError = createSelector(
  selectAccountState,
  (state) => state.error
);

export const selectAccountEditMode = createSelector(
  selectAccountState,
  (state) => state.editMode
);

export const selectAccountIsEditing = createSelector(
  selectAccountState,
  (state) => state.isEditing
);

export const selectAccountForm = createSelector(
  selectAccountState,
  (state) => state.accountForm
);

export const selectAccountId = createSelector(
  selectAccountState,
  (state) => state.accountId
);

export const selectAccount = createSelector(
  selectAccountState,
  (state) => state.account
);
